/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nw_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hyphenate compound numbers from twenty-one to ninety-nine — twenty-one, thirty-eight, ninety-nine — whenever they appear as the tens-and-ones part of a larger number, such as one hundred twenty-one. Round tens like twenty, thirty and forty, and the teens (eleven through nineteen), are single words with no hyphen.`)
};

const es_nw_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserta guiones en números compuestos de twenty-one a ninety-nine — twenty-one, thirty-eight, ninety-nine — siempre que aparezcan como la parte de tens-and-ones de un número más grande, como one hundred twenty-one. Los dieces redondos como twenty, thirty y forty, y los teens (eleven a nineteen), son palabras individuales sin guión.`)
};

const de_nw_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setzen Sie bei zusammengesetzten Zahlen von twenty-one bis ninety-nine einen Bindestrich — twenty-one, thirty-eight, ninety-nine —, wann immer sie als Zehner-und-Einer-Teil einer größeren Zahl erscheinen, wie zum Beispiel bei one hundred twenty-one. Runde Zehner wie twenty, thirty und forty sowie die Zahlen von elf bis neunzehn (eleven bis nineteen) sind einzelne Wörter ohne Bindestrich.`)
};

const nl_nw_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koppel samengestelde getallen van eenentwintig tot negenennegentig — twenty-one, thirty-eight, ninety-nine — wanneer ze voorkomen als het tientallen-en-eenheden-deel van een groter getal, zoals one hundred twenty-one. Ronde tientallen zoals twenty, thirty en forty, en de tienners (elf tot negentien), zijn enkele woorden zonder koppelteken.`)
};

const fr_nw_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettez un trait d'union pour les nombres composés de twenty-one à ninety-nine — twenty-one, thirty-eight, ninety-nine — chaque fois qu'ils apparaissent comme la partie dizaines-et-unités d'un nombre plus grand, comme one hundred twenty-one. Les dizaines rondes comme twenty, thirty et forty, et les adolescents (eleven à nineteen), sont des mots simples sans trait d'union.`)
};

const it_nw_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa i trattini per i numeri composti da twenty-one a ninety-nine — twenty-one, thirty-eight, ninety-nine — ogni volta che appaiono come la parte decine-e-unità di un numero più grande, come 'one hundred twenty-one'. Le decine tonde come twenty, thirty e forty, e i numeri da eleven a nineteen, sono parole singole senza trattino.`)
};

const pt_br2_nw_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicione hífen em números compostos de vinte e um a noventa e nove — vinte e um, trinta e oito, noventa e nove — sempre que aparecerem como a parte das dezenas e unidades de um número maior, como cento e vinte e um. Dezenas redondas como vinte, trinta e quarenta, e os teens (onze a dezenove), são palavras únicas sem hífen.`)
};

const pt_nw_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hifenize números compostos de twenty-one a ninety-nine — twenty-one, thirty-eight, ninety-nine — sempre que apareçam como a parte tens-and-ones de um número maior, tal como one hundred twenty-one. Dezenas redondas como twenty, thirty e forty, e os teens (eleven a nineteen), são palavras únicas sem hífen.`)
};

const ja_nw_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20 から 99 までの複合数字にハイフンを付けます。twenty-one、thirty-eight、ninety-nine。これらはより大きな数字（例えば「one hundred twenty-one」）の十の位と1の位の部分として表示される場合です。twenty、thirty、forty などのラウンド10、および青年期（eleven から nineteen）は、ハイフンのない単語です。`)
};

const zh_nw_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从 twenty-one 到 ninety-nine 的复合数字——如 twenty-one、thirty-eight、ninety-nine——只要它们作为更大数字中十位和个位部分出现，例如 one hundred twenty-one，就需要加连字符。整十的数字如 twenty、thirty 和 forty，以及十几（eleven 到 nineteen）都是不带连字符的单个单词。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nw_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nw_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nw_faq4_a", locale)
	if (locale === "en") return en_nw_faq4_a(inputs)
	if (locale === "es") return es_nw_faq4_a(inputs)
	if (locale === "de") return de_nw_faq4_a(inputs)
	if (locale === "nl") return nl_nw_faq4_a(inputs)
	if (locale === "fr") return fr_nw_faq4_a(inputs)
	if (locale === "it") return it_nw_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_nw_faq4_a(inputs)
	if (locale === "pt") return pt_nw_faq4_a(inputs)
	if (locale === "ja") return ja_nw_faq4_a(inputs)
	return zh_nw_faq4_a(inputs)
};